// extracted by mini-css-extract-plugin
export var formContainer = "_cl-0";
export var message = "_cl-1";